import React, { useEffect, useMemo, useState } from 'react'
import Facade from '@whitecobalt/tungsten/esm/components/Facade';
import Icon from '@whitecobalt/tungsten/esm/components/Icon';
import { useScreenTitle } from '@whitecobalt/tungsten/hooks/useScreenTitle'
import { useLazyQuery } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import ProductThumbnail from '../Prefabs/ProductThumbnail';
import ProductFilter, { StateProps } from '../Prefabs/ProductFilter';
import { SealProductPropType, SealProductsSearchQuery, ShopMasterProductHardwareQuery, ShopMasterProductHardwareQueryType, ShopProductSealsQuery, ShopProductSealsQueryType } from '@services/query/EcommerceQueries';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { emptyArray } from '@whitecobalt/tungsten/esm/common/utils/assets';
import FileKeyLoader from '@whitecobalt/tungsten/esm/components/FileKeyLoader';
import useWindowDimensions from '@utils/getWindowDimensions';
import Slider from '@whitecobalt/tungsten/Slider'
interface MasterProductsProps {
	type: 'closers' | 'hinges' | 'locks' | 'others' | 'letterbox' | 'handlesFingerPlates' | 'cylinders' | 'kits' | 'glazingSeals';
	menuDescription?: string;
	shopLinks: {
        label: string;
        value: string;
    }[]
    productTypeURL?: string;
	productCategoryURL?: string;
}

const MasterProducts: React.FunctionComponent<MasterProductsProps> = ({type, menuDescription, shopLinks, productTypeURL, productCategoryURL}) => {
    const isCloser = type === 'closers'
    const isHinge = type === 'hinges'
    const isLock = type === 'locks'
	const isKit = type === 'kits'
	const isGlazing = type === 'glazingSeals'
	const isCylinder = type === 'cylinders'
	const isLetterPlates = type === 'letterbox'
    const handlesFingerPlates = type === 'handlesFingerPlates'
    const isOther = type === 'others'
	const { height, width } = useWindowDimensions();

    const title = isCloser ? 'Closers' : isCylinder ? 'Cylinders' : isHinge ? 'Hinges' : isLock ? 'Locks' : isLetterPlates ? 'Letterplates':  handlesFingerPlates ?  'Handles/Finger Plates' : isKit ? "Seal Kits" : isGlazing ? 'Glazing Seals' :  'Ancillary Items'
	

    useScreenTitle(`Halspan Store - ${title}`);
	
	const history = useHistory()

	const [filters, setFilters] = useState<Pick<StateProps, 'fireRating' | 'price' | 'concealed' | 'finish' | 'powered' | 'includePoA' | 'excludeNoFinishType'>>({
		fireRating: [],
		price: [1, 10000],
		includePoA: null,
		concealed: null,
		finish: [],
		powered: null,
		excludeNoFinishType: false,
	})

	const [loadProducts, request] = useLazyQuery<ShopMasterProductHardwareQueryType>(ShopMasterProductHardwareQuery, {
		fetchPolicy: 'no-cache'
	})

	const productTypeID = isLetterPlates ? 8 : handlesFingerPlates ?  20  : isOther ?  9 : isCloser ? 3 : isCylinder ? 19 : isLock ? 4 : isHinge ? 5 : isKit ? 14 : isGlazing ? 12 : 0;
	
	const variables = {
		request: {
            ProductTypeID: productTypeID,
            FireRatingIDs: filters.fireRating.length > 0 ? filters.fireRating : null,
            Concealed: filters.concealed,
            FinishTypeIDs: filters.finish.length > 0 ? filters.finish : [],
            Powered: filters.powered,
            IncludePOA: filters.includePoA,
			MinPrice: filters.price[0],
			MaxPrice: filters.price[1],
			ExcludeNoFinishType: filters.excludeNoFinishType,
		},
		order: { Product: { Name: "ASC" }}
	}

	useEffect(() => {
		loadProducts({
			variables
		})
	}, [type, filters])

    const data = useMemo(() => request.data?.ShopMasterProductHardware?.items.filter(item => item) || emptyArray
	, [request.data?.ShopMasterProductHardware?.items])

	useEffect(()=>{
		if(data?.length === 1 && !request?.loading){
			let masterProductID = data[0]?.ID;
			history.push(`/store/master-product/master/${masterProductID}/type/${productTypeID}`)
		}
	})

	const fileKeys = useMemo(() => {
		return data.filter((each) => !!each.MasterProductImages[0]?.ImageUrl).map((each) => {
			return each.MasterProductImages[0]?.ImageUrl
		})
	}, [data])

	const multiFetchPayload = useMemo(() => ({
		"maxWidthInPX": 175,
		"maxHeightInPX": 175,
	}), [])
    
    return (
		<>
			<div className="row">
				<div className="col-md-3 wc-sidebar-menu wc-products-home-side-menu wc-search-products">
					<ProductFilter 
						shopLinks={shopLinks}
						productTypeName={ (isKit || isGlazing) ? "Seals" : "Hardware"}
						productCategory={title}
						menuDescription={menuDescription}
						hasPrice
						hasFireRating={!isOther && !handlesFingerPlates}
						hasConcealed={isCloser}
						hasPowered={isCloser}
						maxPrice={(isLock || isHinge || isOther) ? 500 : isCloser ? 1000 : 10000}
						hasFinish
						isFireRatingNoSmoke
						type={type}
						onChange={(events) => {
							setFilters(prev => ({
								...prev,
								...events
							}))
						}}
						productTypeURL={productTypeURL}
						productCategoryURL={productCategoryURL}
						 />
				</div>
				<div className="col-md-9">
					<div className="row">
						<FileKeyLoader.MultiFetch
							fileKeys={fileKeys}
							payload={multiFetchPayload}
							cache
							cacheUniqueString="175px"
						>
							{data.length > 0 ? data.map((item) => {
								return (

									<div key={item.ID} className="col-sm-6 col-lg-4 col-xl-3">
										<ProductThumbnail 
											productName={item.Name} 
											fileKey={(item.DefaultMasterProductImage?.Value?.ImageUrl || item.MasterProductImages[0]?.ImageUrl)} 
											url={`/store/master-product/master/${item.ID}/type/${productTypeID}`}
											/>
									</div>
								)
							}) : request.loading ? (
								new Array(8).fill(0).map((_: any, index) => (
									<div key={index} className="col-sm-6 col-lg-4 col-xl-3 wc-product-search-item">
										<div className="product-thumbnail">
											<h4><Facade title rows={0} padding={false} rowListStyle={{margin: 0}} /></h4>
											<Facade rows={1} padding={false} rowListStyle={{margin: 0}} rowStyle={{ borderRadius: 0, width: '100%', height: 150}} />
										</div>
									</div>
								))
							) : (
								<div className="d-flex justify-content-center w-100">
									<div className="text-center my-5">
										<Icon name="inbox" size={25}/>
										<h4 className="mt-2">No {title} to display</h4>
									</div>
								</div>
							)}
						</FileKeyLoader.MultiFetch>
					</div>
				</div>
			</div>   
		</>
    )
}

export default MasterProducts